/*
 * @Author: lishiqiao
 * @Date: 2022-01-17 10:32:01
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-01-17 15:30:43
 */
import http from "@/axios/index";
import Page from "@/utils/methods/page"

export default {
    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 10:38:53
     * @description: 投苗情况--查询顶级机构下的所有子机构
     * @param {*} rootId 顶级机构id
     */
    getSeedlingCompanyList(rootId) {
        const url = `/desktopReport/querySubsidiaryFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 10:41:40
     * @description: 投苗情况--查询顶级机构下的所有造次
     * @param {*} rootId
     */
    getSeedlingPeriodList(rootId) {
        const url = `/desktopReport/queryPerioyFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 10:43:57
     * @description: 投苗情况--查询顶级机构下的所有品类
     * @param {*} rootId
     */
    getSeedlingBreedTypeList(rootId) {
        const url = `/desktopReport/queryTypeFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 10:45:23
     * @description: 投苗情况--查询顶级机构下的所有品种
     * @param {*} rootId
     */
    getSeedlingBreedList(rootId) {
        const url = `/desktopReport/queryBreedFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 10:57:39
     * @description: 排塘情况--查询顶级机构下的所有机构
     * @param {*} rootId
     */
    getPondCompanyList(rootId) {
        const url = `/desktopReport/queryPaiOrgFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 10:58:24
     * @description: 排塘情况--查询顶级机构下的所有造次
     * @param {*} rootId
     */
    getPondPeriodList(rootId) {
        const url = `/desktopReport/queryPaiPerioyFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 10:59:23
     * @description: 排塘情况--查询顶级机构下的所有品类
     * @param {*} rootId
     */
    getPondBreedTypeList(rootId) {
        const url = `/desktopReport/queryPaiTypeFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 11:00:03
     * @description: 排塘情况--查询顶级机构下的所有品种
     * @param {*} rootId
     */
    getPondBreedList(rootId) {
        const url = `/desktopReport/queryPaiBreedFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 11:05:56
     * @description: 投放概览-养殖投苗情况报表-分页
     * @param {*} params
     */
    getSeedlingPageList(params) {
        const url = `/outSeedlingDailyOrg/searchOutSeedlingDailyOrgList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 11:10:26
     * @description: 投放概览-养殖投苗、卵情况报表-（养成、育苗）分页导出
     * @param {*} params
     */
    exportSeedlingData(params) {
        const url = `/outSeedlingDailyOrg/exportOutSeedlingDailyOrgList`;
        return Page.exportDatas(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 11:12:21
     * @description: 投放概览-排塘情况报表-养成、育苗分页
     * @param {*} params
     */
    getPondPageList(params) {
        const url = `/mdtLossOrg/searchMdtLossOrgList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 11:13:10
     * @description: 投放概览-排塘况报表-（养成、育苗）分页导出
     * @param {*} params
     */
    exportPondData(params) {
        const url = `/mdtLossOrg/exportMdtLossOrgList`;
        return Page.exportDatas(url, params)
    },
}